import { Checkbox as MUICheckBox } from "@mui/material";
import Box from "@mui/material/Box";
import { tokens } from "styles/Tokens";

interface Props {
  id?: string;
  checked: boolean;
  onChange?: any;
  indeterminate?: boolean;
  sx?: any;
  className?: string;
}

const Indeterminate = () => {
  return (
    <Box
      sx={{
        height: "18px",
        width: "18px",
        borderRadius: "4px",
        border: `2px solid ${tokens.Border.General.Secondary}`,
        padding: "3px",
        margin: "3px"
      }}
    >
      <Box sx={{ backgroundColor: tokens.Icon.General.Color, width: "8px", height: "8px", borderRadius: "2px" }} />
    </Box>
  );
};

function CheckBox(props: Props) {
  const { id, checked, onChange, indeterminate, sx, className } = props;

  return (
    <MUICheckBox
      className={className}
      sx={{
        ...sx,
        color: tokens.Border.General.Secondary,
        borderRadius: "4px",
        "&:hover, &:focus": {
          color: tokens.Border.General.Color
        },
        "&.Mui-checked": {
          color: tokens.Icon.General.Color
        },
        "&.Mui-disabled": {
          opacity: "0.5",

          "+.MuiFormControlLabel-label": {
            opacity: "0.5"
          }
        }
      }}
      disableRipple={true}
      id={id}
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      indeterminateIcon={<Indeterminate />}
    />
  );
}

export default CheckBox;
